<template>
  <VDropdown
    ref="dropdownRef"
    :distance="1"
    placement="bottom-end"
    :triggers="['click']"
    :auto-hide="true"
    @hide="isMenuOpen = false"
  >
    <!-- 햄버거 버튼 (트리거) -->
    <button
      type="button"
      class="nav-menu-icon"
      :class="{ open: isMenuOpen }"
      :aria-label="isMenuOpen ? '메뉴 닫기' : '메뉴 열기'"
      :aria-expanded="isMenuOpen"
      @click="toggleMenu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- 드롭다운 내용 (서브메뉴) -->
    <template #popper="{ hide }">
      <div class="submenu" ref="submenuEl">
        <div v-if="isMobile" class="util-box">
          <div class="util-link">
            <UtilLinks @close="hide" />
          </div>
        </div>
        <ul>
          <li>
            <router-link
              :to="{ name: 'Home' }"
              :class="{ on: $route.path === '/' }"
              @click="hide"
              >HOME</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'ArtistList' }"
              :class="{ on: $route.path.startsWith('/artist') }"
              @click="hide"
            >
              ART & ARTISTS
            </router-link>
          </li>

          <li
            class="depth"
            @click="mobileToggleMenu('article')"
            :class="{ open: activeMenu === 'article' }"
          >
            <a :class="{ on: $route.path.startsWith('/article') }">
              <span>ARTICLE</span>
              <img
                src="../../../assets/images/icon/ico_select_wh2.svg"
                alt=""
                :class="{ 'rotate-180': activeMenu === 'article' }"
              />
            </a>
            <div class="m-depth" v-show="activeMenu === 'article'">
              <ul class="depth-2">
                <li :class="{ on: $route.path.startsWith('/article/special') }">
                  <router-link :to="{ name: 'Special' }" @click="hide"
                    >SPECIAL</router-link
                  >
                </li>
                <li
                  :class="{ on: $route.path.startsWith('/article/exhibition') }"
                >
                  <router-link :to="{ name: 'Exhibition' }" @click="hide"
                    >EXHIBITION</router-link
                  >
                </li>
                <li :class="{ on: $route.path.startsWith('/article/event') }">
                  <router-link :to="{ name: 'Event' }" @click="hide"
                    >EVENT</router-link
                  >
                </li>
                <li :class="{ on: $route.path.startsWith('/article/news') }">
                  <router-link :to="{ name: 'News' }" @click="hide"
                    >NEWS</router-link
                  >
                </li>
              </ul>
            </div>
          </li>

          <li
            v-if="currentUser"
            class="depth"
            @click="mobileToggleMenu('mypage')"
            :class="{ open: activeMenu === 'mypage' }"
          >
            <a :class="{ on: route.path.startsWith('/my') }">
              <span>MY PAGE</span>
              <img
                src="../../../assets/images/icon/ico_select_wh2.svg"
                alt=""
                :class="{ 'rotate-180': activeMenu === 'mypage' }"
              />
            </a>
            <div class="m-depth" v-show="activeMenu === 'mypage'">
              <ul
                v-if="isArtist || isArtistBeforeProfile || isArtistPending"
                class="depth-2"
              >
                <li>ART & ARTISTS</li>
                <li
                  @click="
                    () => {
                      handleArtistMenuClick('profile');
                      hide();
                    }
                  "
                  :class="{ on: route.path.startsWith('/my/artist/profile') }"
                >
                  <router-link
                    v-if="!isArtistPending"
                    :to="{ name: 'MyProfile' }"
                  >
                    프로필 관리
                  </router-link>
                  <a v-else href="#">프로필 관리</a>
                </li>
                <li
                  @click="
                    () => {
                      handleArtistMenuClick('ProfileArtWork');
                      hide();
                    }
                  "
                  :class="{ on: route.path.startsWith('/my/artist/artwork') }"
                >
                  <router-link
                    v-if="!isArtistPending && !isArtistBeforeProfile"
                    :to="{ name: 'ProfileArtWork' }"
                  >
                    아트워크 관리
                  </router-link>
                  <a v-else href="#">아트워크 관리</a>
                </li>
                <li
                  @click="
                    () => {
                      handleArtistMenuClick('Portfolio');
                      hide();
                    }
                  "
                  :class="{ on: route.path.startsWith('/my/artist/portfolio') }"
                >
                  <router-link
                    v-if="!isArtistPending && !isArtistBeforeProfile"
                    :to="{ name: 'Portfolio' }"
                    >포트폴리오 제작</router-link
                  >
                  <a v-else href="#">포트폴리오 제작</a>
                </li>
              </ul>
              <ul v-if="isBusiness" class="depth-2">
                <li>MY ORGANIZATION</li>
                <li
                  @click="hide"
                  :class="{
                    on: route.path.startsWith('/organization/contest'),
                  }"
                >
                  <router-link :to="{ name: 'ContestManage' }"
                    >공모전 관리</router-link
                  >
                </li>
              </ul>
              <ul class="depth-2">
                <li>MY FAVORITE</li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/favorite/artist') }"
                >
                  <router-link :to="{ name: 'FavoriteArtist' }"
                    >관심 아티스트</router-link
                  >
                </li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/favorite/artwork') }"
                >
                  <router-link :to="{ name: 'FavoriteArtwork' }"
                    >관심 아트워크</router-link
                  >
                </li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/favorite/article') }"
                >
                  <router-link :to="{ name: 'FavoriteArticle' }"
                    >스크랩 아티클</router-link
                  >
                </li>
              </ul>
              <ul class="depth-2">
                <li>회원 정보 관리</li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/info') }"
                >
                  <router-link :to="{ name: 'MyPage' }">나의 정보</router-link>
                </li>
              </ul>
              <ul class="depth-2">
                <li>고객 센터</li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/support/notice') }"
                >
                  <div
                    class="link-wrapper"
                    :class="{ new: unreadStore.unreadNoticesCount > 0 }"
                  >
                    <router-link :to="{ name: 'Notice' }"
                      >공지 사항</router-link
                    >
                  </div>
                </li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/support/faq') }"
                >
                  <router-link :to="{ name: 'FAQ' }">FAQ</router-link>
                </li>
                <li
                  @click="hide"
                  :class="{ on: route.path.startsWith('/my/support/inquiry') }"
                >
                  <div
                    class="link-wrapper"
                    :class="{
                      new: unreadStore.unreadAnsweredInquiriesCount > 0,
                    }"
                  >
                    <router-link :to="{ name: 'Inquiry' }"
                      >1:1 문의</router-link
                    >
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a
              href="#"
              v-close-popper
              @click.prevent="onApplyCollab"
              class="link-apply-collab link-apply-collab-mobile"
              >협업 신청</a
            >
          </li>
          <li>
            <a
              :href="router.resolve({ name: 'ServiceInfo' }).href"
              target="_blank"
              class="link-apply-service link-apply-service-mobile"
              :style="{
                borderColor: route.path.includes('/info/service')
                  ? '#F7BE17'
                  : '',
                color: route.path.includes('/info/service') ? '#F7BE17' : '',
              }"
              rel="noopener noreferrer"
              >서비스 소개</a
            >
          </li>
        </ul>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import UtilLinks from "@/components/layout/header/UtilLinks.vue";
import { useAuthInfo } from "@/composables/useAuthInfo";
import { useAuthStore } from "@/store/auth.module";
import { useUnreadStore } from "@/store/unread.module";
import { defineProps, onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const {
  currentUser,
  isArtist,
  isArtistBeforeProfile,
  isArtistPending,
  isBusiness,
} = useAuthInfo();

const unreadStore = useUnreadStore();
const authStore = useAuthStore();

const router = useRouter();
const route = useRoute();
const isMenuOpen = ref(false);
const dropdownRef = ref(null);
const submenuEl = ref(null);
const props = defineProps({
  isMobile: Boolean,
  linkApplyCollab: String,
});

const emit = defineEmits(["apply-collab"]);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const onApplyCollab = () => {
  emit("apply-collab");
  isMenuOpen.value = false;
};

const closeMenu = () => {
  isMenuOpen.value = false;
  dropdownRef.value?.hide();
};

const activeMenu = ref(null); // 활성화된 메뉴를 추적하는 변수

// 메뉴 토글 함수
const mobileToggleMenu = (menu) => {
  activeMenu.value = activeMenu.value === menu ? null : menu;
};

const handleArtistMenuClick = async (btn) => {
  await authStore.refreshRoleType();

  if (isArtistPending.value) {
    alert(
      "승인 대기 중이므로 해당 메뉴를 이용할 수 없습니다.\n" +
        "가입 완료 메일 수신 후 이용해 주세요."
    );
    closeMenu();
    return;
  }

  if (btn !== "profile" && isArtistBeforeProfile.value) {
    alert("프로필을 먼저 등록해 주세요.");
    closeMenu();
    await router.push({ name: "MyProfile" });
    return;
  }

  closeMenu();
};


const isInteractingInsideMenu = ref(false);

// 메뉴 내부에서 상호작용 시작했는지 체크
const onStartInteraction = (e) => {
  const target = e.target;
  isInteractingInsideMenu.value = submenuEl.value?.contains(target);
};

// 스크롤/터치 이동 시, 외부 시작이면 닫기
const onMoveInteraction = () => {
  if (!isMenuOpen.value) return;
  if (!isInteractingInsideMenu.value) {
    closeMenu();
  }
};

onMounted(() => {
  // PC
  window.addEventListener("mousedown", onStartInteraction, { passive: true });
  window.addEventListener("scroll", onMoveInteraction, { passive: true });

  // 모바일
  window.addEventListener("touchstart", onStartInteraction, { passive: true });
  window.addEventListener("touchmove", onMoveInteraction, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener("mousedown", onStartInteraction);
  window.removeEventListener("scroll", onMoveInteraction);
  window.removeEventListener("touchstart", onStartInteraction);
  window.removeEventListener("touchmove", onMoveInteraction);
});
</script>

<style scoped>
/* 햄버거 메뉴 s */
.nav-menu-icon {
  position: relative;
  width: 32px;
  height: 28px;
  cursor: pointer;
  background: none;
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 7px;
  margin-left: 6px;
}

.nav-menu-icon span {
  position: absolute;
  display: block;
  width: 24px;
  height: 3px;
  background-color: #fff; /* 검정 배경 대비 흰색 */
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* 기본 상태 - 세 줄 */
.nav-menu-icon span:nth-child(1) {
  top: 6px;
}

.nav-menu-icon span:nth-child(2) {
  top: 12.5px; /* 중앙 */
}

.nav-menu-icon span:nth-child(3) {
  top: 19px;
}

/* open 상태 - X */
.nav-menu-icon.open span:nth-child(1) {
  transform: rotate(45deg);
  top: 12.5px;
}

.nav-menu-icon.open span:nth-child(2) {
  opacity: 0;
}

.nav-menu-icon.open span:nth-child(3) {
  transform: rotate(-45deg);
  top: 12.5px;
}

/* 햄버거 메뉴 e */

/* 드롭다운 메뉴 s*/
.submenu {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

.submenu {
  background: #151419;
  padding: 20px;
  min-width: 200px;
  max-height: 75dvh;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 100;
  justify-content: flex-end;
  position: relative;
}

.submenu .util-box .util-link {
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.submenu ul {
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
}

.submenu ul::-webkit-scrollbar {
  display: none;
}

.submenu ul li {
  width: 100%;
  font-family: "Poppins", "SUIT", sans-serif;
  display: flex;
  justify-content: flex-end;
  text-transform: uppercase;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.submenu ul li a {
  font-family: "Poppins";
  display: block;
  font-size: 18px;
  font-weight: normal;
  color: #fff;
  padding: 0 10px;
  transition: all 0.3s;
  letter-spacing: -0.03em;
}

.submenu ul li a:hover {
  color: #f7be17;
}

.submenu ul li a.on {
  color: #f7be17;
}

.submenu ul li a {
  font-size: 25px;
  padding: 0;
  text-align: right;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
}

.submenu ul li.on > a {
  color: #f7be17;
  text-decoration: underline;
}

.submenu ul li a img {
  transition: transform 0.3s ease;
}

.submenu ul li.depth {
  cursor: pointer;
}

.submenu ul li.depth > a > img.rotate-180 {
  transform: rotate(180deg);
}

.submenu ul li .m-depth {
  display: none;
  flex-direction: column;
  gap: 30px;
}

.submenu ul li .m-depth.active {
  display: flex;
}

.submenu ul li .m-depth ul {
  margin: 0;
  padding: 0;
}

.submenu ul li .m-depth ul li {
  list-style: none;
}

.submenu ul li.depth.open .m-depth {
  display: flex;
}

.submenu ul li.depth .m-depth .depth-2 {
  padding-right: 25px;
  gap: 11px;
}

.submenu ul li.depth .m-depth .depth-2 li {
  color: #fff;
  font-size: 18px;
}

.submenu ul li.depth .m-depth .depth-2 li a {
  font-family: "Poppins", "SUIT", sans-serif;
  color: #999;
  font-size: 16px;
}

.submenu ul li.depth .m-depth .depth-2 li a:hover {
  color: #f7be17;
}

.submenu ul li.depth .m-depth .depth-2 li.on a {
  color: #fff3ce;
  text-decoration: underline;
}

.submenu .link-wrapper {
  display: flex;
  align-items: center;
}

.submenu .link-wrapper.new::before {
  content: "N";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #f00;
  color: #fff;
  font-size: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  /* 간격 추가 */
}

.submenu .link-apply-collab-mobile,
.submenu .link-apply-service-mobile {
  font-family: Poppins;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 30px;
  border-radius: 30px;
  border: solid 1px #fff3ce;
  font-size: 14px !important;
  color: #fff3ce;
}

.submenu .link-apply-collab-mobile:hover,
.submenu .link-apply-service-mobile:hover {
  border-color: #f7be17;
}

/* 드롭다운 메뉴 e*/
</style>
